<template>
    <div class="timer"
         :style="{'--player-color-main': currentPlayerColor()}"
        :class="{
            'timer--running': isRunning,
            'timer--paused': onPause
        }">
        {{/*
        Описание принципа работы таймера:
        - Если таймер запущен с начальным значением "00:00" - то просто считает сколько прошло времени (инкремент)
        - Если таймер запущен с отличным от "00:00" начальным значением - то идёт обратный отсчет от установленного значения (декремент)
        - При остановке таймера, запущенного в режиме инкремента - режим инкремента сохраняется при возобновлении
        */}}
        <template v-if="editable">
            <button class="timer__reset" type="button" v-if="!isGuest && (isRunning || onPause)" @click="resetTimer">
                <svg><use xlink:href="#ic_reload"></use></svg>
            </button>

            <button v-if="!isGuest && !isRunning" class="timer__control" type="button" @click="onPause ? resumeTimer() : startTimer()">
                <svg><use xlink:href="#ic_play"></use></svg>
            </button>
            <button v-if="!isGuest && isRunning" class="timer__control" type="button" @click="pauseTimer()">
                <svg><use xlink:href="#ic_pause"></use></svg>
            </button>
        </template>

        <input type="text"
               class="timer__value"
               placeholder="00:00"
               v-model="timerValue"
               @input="inputTimerValue($event.target)"
               @focus="makeEditable"
               @blur="makeReadOnly"
               @keydown.enter="$event.target.blur()"
               :readonly="isReadonly">
    </div>
</template>

<script>
    import store from "../store";
    import EventApi from "../api/EventsApi";

    const STATUS_START = 1;
    const STATUS_PAUSE = 2;
    const STATUS_RESET = 3;
    const STATUS_SET_TIME = 4;
    const STATUS_RESUME = 5;

    const TYPE_TIMER = 1;
    const TYPE_STOPWATCH = 2;

    export default {
        props: {
            changeTimerFunction: {
                required: true,
                type: Function
            },
            editable: {
                default: true,
                type: Boolean
            }
        },

        data() {
            return {
                timerSeconds: 0,
                timerValue: '00:00',
                runTimerInterval: null,
                onPause: false,
                isRunning: false,
                isReadonly: true,
                fromZero: true,
                maxValue: null,
                type: null,
                playerId: null,
                color: null,
                timer: null
            }
        },

        computed: {
            players: () => store.getters.getPlayers,
            /**
             * Настройки автоматизации игры
             */
            gameAutomation: () => store.getters.getGameState.automation,
            isGuest: () => store.getters.getPlayerConnectionStatus === 'guest'
        },
        watch: {
            timerValue: function (newValue, oldValue) {
                if (this.isStopwatch()) {

                } else {
                    if (this.timerSeconds === 0) {
                        this.playAudio();
                    }
                }
            }
        },
        methods: {
            /**
             * Воспроизвести аудио по окончанию таймера
             */
            playAudio() {
                EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'timerEnded'});
            },

            /**
             * Цвет игрока, который ходит
             */
            currentPlayerColor: function() {
                let color = '#F65A00';
                if (!this.gameAutomation) {
                    return color;
                }

                let masterPlayerId = '';
                for (let player in this.gameAutomation.playersMap) {
                    if (this.gameAutomation.playersMap[player].master) {
                        masterPlayerId = this.gameAutomation.playersMap[player].playerId;
                    }
                }

                const filtered = this.players.filter(player => player.id === masterPlayerId);

                if (typeof filtered[0] !== 'undefined') {
                    color = filtered[0].color.code;
                }

                return color;
            },

            makeReadOnly()
            {
                if (!this.editable) {
                    return;
                }
                this.isReadonly = true;
            },

            makeEditable()
            {
                if (!this.editable || this.isGuest) {
                    return;
                }
                this.editable ? this.isReadonly = false : this.isReadonly = true;
                this.pauseLocalTimer();
                this.pauseTimer();
            },

            /**
             * Остановить локальный таймер
             */
            pauseLocalTimer()
            {
                this.onPause = true;
                this.isRunning = false;
                clearInterval(this.runTimerInterval);
            },

            /**
             * Изменить время таймера
             */
            setTimer()
            {
                if (this.timerSeconds === 0) {
                    this.fromZero = true;
                }
                this.changeTimerFunction(this.timerSeconds, STATUS_SET_TIME);
            },

            /**
             * Запуск таймера
             */
            startTimer()
            {
                EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
                this.changeTimerFunction(this.timerSeconds, STATUS_START);
            },

            /**
             * Пауза таймера
             */
            pauseTimer()
            {
                EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
                this.changeTimerFunction(this.timerSeconds, STATUS_PAUSE);
            },

            /**
             * Сброс таймера
             */
            resetTimer()
            {
                EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
                this.changeTimerFunction(this.timerSeconds, STATUS_RESET);
            },

            /**
             * Возобновление таймера
             */
            resumeTimer()
            {
                EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
                this.changeTimerFunction(this.timerSeconds, STATUS_RESUME);
            },

            /**
             * Режим - секундомер
             */
            isStopwatch()
            {
                return this.type === TYPE_STOPWATCH;
            },

            /**
             * Показать таймер
             */
            showTimer(timer, currentTime)
            {
                if (!timer) {
                    return;
                }
                this.timer = timer;
                this.playerId = timer.playerId;
                this.maxValue = timer.maxValue;
                this.type = timer.type;
                this.color = timer.color;

                clearInterval(this.runTimerInterval);
                this.onPause = false;

                let timeDiff = timer.endTime - currentTime;
                if (timeDiff < 0) {
                    timeDiff = 0;
                }

                this.fromZero = false;

                if (this.isStopwatch()) {
                    if (!this.isRunning) {
                        this.timerSeconds = timer.endTime - timer.startTime;
                    } else {
                        this.timerSeconds = currentTime - timer.startTime;
                    }

                    if (this.timerSeconds < 0) {
                        this.timerSeconds = 0;
                    }
                }

                /**
                 * Секундомер
                 */
                let stopwatch = () => {
                    let minutes = Math.floor(this.timerSeconds / 60).toString().padStart(2, '0');
                    let seconds = (this.timerSeconds % 60).toString().padStart(2, '0');
                    this.timerValue = `${minutes}:${seconds}`;

                    // ограничение секундомера
                    if (this.isStopwatch() && this.maxValue && this.timerSeconds >= this.maxValue) {
                        if (this.timerSeconds === this.maxValue) {
                            this.playAudio();
                        }

                        this.pauseLocalTimer();
                        return;
                    }
                    this.timerSeconds++;
                };

                let runTimer = () => {
                    if (!this.fromZero) {
                        if (timer.type === TYPE_TIMER) {
                            let minutes = Math.floor(timeDiff / 60).toString().padStart(2, '0');
                            let seconds = (timeDiff % 60).toString().padStart(2, '0');
                            this.timerValue = `${minutes}:${seconds}`;
                            this.timerSeconds = timeDiff;
                            if (timeDiff <= 0) {
                                return;
                            }
                            timeDiff--;
                        } else {
                            stopwatch();
                        }
                    } else {
                        stopwatch();
                    }
                };

                let startTimer = () => {
                    runTimer();
                    this.runTimerInterval = setInterval(runTimer, 1000);
                };

                if ((timer.status === STATUS_START || timer.status === STATUS_RESUME)) {
                    startTimer();
                    this.isRunning = true;
                } else if (timer.status === STATUS_RESET) {
                    this.resetTimerParams(timer, currentTime);
                    this.isRunning = false;
                } else if (timer.status === STATUS_PAUSE) {
                    this.onPause = true;
                    this.isRunning = false;
                }
            },

            /**
             * Цвет таймера
             */
            getColor()
            {
                if (this.color) {
                    return this.color;
                }

                let color = null;

                this.players.forEach((player) => {
                    if (player.id === this.playerId) {
                        color = player.color.code;
                    }
                });
                return color;
            },

            /**
             * Получение количества секунд из значения инпута
             */
            parseTimerValue()
            {
                let time = this.timerValue.split(':');
                this.timerSeconds = parseInt(time.pop()) + parseInt(time.pop()) * 60;
                this.fromZero = (this.timerSeconds === 0);
                this.setTimer();

                this.onPause = true;
                this.isRunning = false;
            },

            /**
             * Обработка ввода времени
             */
            inputTimerValue(inputElement)
            {
                if (!this.editable) {
                    return;
                }
                let selectionStart = inputElement.selectionStart;
                inputElement.value = inputElement.value.replace(/\D/gi, '').replace(/(\d{1,2})(\d{2}).*/, '$1:$2');
                this.timerValue = inputElement.value;
                this.parseTimerValue();
                // перескакиваем двоеточие
                if (selectionStart === 3) {
                    selectionStart++;
                }
                Vue.nextTick(() => {
                    inputElement.setSelectionRange(selectionStart, selectionStart);
                });
            },

            /**
             * Сброс параметров таймера до начальных
             */
            resetTimerParams(timer, currentTime) {
                this.isRunning = false;

                let minutes = Math.floor(timer.duration / 60).toString().padStart(2, '0');
                let seconds = (timer.duration % 60).toString().padStart(2, '0');
                this.timerValue = `${minutes}:${seconds}`;
                this.timerSeconds = timer.duration;

                if (timer.type === TYPE_STOPWATCH) {
                    this.timerSeconds = 0;
                    this.timerValue = `00:00`;
                    this.fromZero = true;
                }


                clearInterval(this.runTimerInterval);
            }
        }
    }
</script>
